/**
 * Day the admin calendar week starts on, chosen per tenant in the Calendar settings. Cinema
 * programme weeks run Friday to Thursday because new releases open on Friday, so Friday is the
 * default; Monday gives an ordinary calendar week. The value is a day-of-week index with Sunday
 * as 0, the convention shared by FullCalendar's firstDay and moment's week.dow.
 */
type WeekStart = 'friday' | 'monday';

const WEEK_START_DAYS: Record<WeekStart, number> = {
    friday: 5,
    monday: 1,
};

export const weekStartDay = (): number => {
    const weekStart: WeekStart | undefined = window.app.calendar?.week_start;

    return (weekStart && WEEK_START_DAYS[weekStart]) ?? WEEK_START_DAYS.friday;
};
